import { buildCampaignAnalysisCacheKey } from "helpers/sf_utils"

const getUniqueCampaignAnalysisRows = (rows = []) => {
  const uniqueCampaignAnalysis = []

  rows.forEach((item) => {
    const existingIndex = uniqueCampaignAnalysis.findIndex((existingItem) => existingItem.id == item.id)

    if (existingIndex <= -1) {
      uniqueCampaignAnalysis.push(item)
    }
  })

  return uniqueCampaignAnalysis
}

export const handleGetCampaignAnalysis = (state, action) => {
  let page_number = 1
  if (action.paginated) {
    page_number = action.payload.queryParams.page_number
  }

  const useCache = Boolean(action.payload?.useCache)
  const queryParams = action.payload?.queryParams || {}
  const cacheKey = useCache ? buildCampaignAnalysisCacheKey(queryParams) : null
  const shouldResetCache =
    useCache &&
    page_number === 1 &&
    !action.payload?.appendResults &&
    state.active_cache_key &&
    state.active_cache_key !== cacheKey
  const cachedPage = useCache ? state.page_cache?.[cacheKey]?.[page_number] : null

  return {
    ...state,
    error: null,
    active_cache_key: useCache ? cacheKey : null,
    loading: !cachedPage,
    campaign_analysis: cachedPage?.rows || ((page_number === 1 || !action.payload?.appendResults) ? [] : state.campaign_analysis),
    last_page_fetched: cachedPage?.page_number || state.last_page_fetched,
    total_number_of_pages: cachedPage?.total_number_of_pages || state.total_number_of_pages,
    has_next_page: typeof cachedPage?.has_next_page === 'boolean' ? cachedPage.has_next_page : state.has_next_page,
    has_lookahead_pages: typeof cachedPage?.has_lookahead_pages === 'boolean'
      ? cachedPage.has_lookahead_pages
      : state.has_lookahead_pages,
    last_start_date: cachedPage?.start_date || state.last_start_date,
    last_end_date: cachedPage?.end_date || state.last_end_date,
    page_cache: shouldResetCache ? {} : state.page_cache,
  }
}

export const handleGetCampaignAnalysisSuccess = (state, action) => {
  const payloadData = action.payload.data
  const rows = Array.isArray(payloadData) ? payloadData : []
  const additional = action.payload.additional_data || {}
  const useCache = Boolean(action.meta?.useCache)
  const queryParams = action.meta?.queryParams || {}
  const cacheKey = useCache ? buildCampaignAnalysisCacheKey(queryParams) : null
  const appendResults = Boolean(action.meta?.appendResults)
  const pageNum = parseInt(additional.page_number, 10)
  const totalPages = parseInt(additional.total_number_of_pages, 10)
  const safePage = Number.isFinite(pageNum) && pageNum > 0 ? pageNum : 1
  const safeTotal = Number.isFinite(totalPages) && totalPages >= 0 ? totalPages : 0
  const hasNextPage =
    typeof additional.has_next_page === 'boolean'
      ? additional.has_next_page
      : false
  const hasLookAheadPages =
    typeof additional.has_lookahead_pages === 'boolean'
      ? additional.has_lookahead_pages
      : false
  const pageSnapshot = {
    rows,
    page_number: safePage,
    total_number_of_pages: safeTotal,
    has_next_page: hasNextPage,
    has_lookahead_pages: hasLookAheadPages,
    start_date: additional.start_date,
    end_date: additional.end_date,
  }

  return {
    ...state,
    error: null,
    active_cache_key: useCache ? cacheKey : state.active_cache_key,
    campaign_analysis: appendResults
      ? getUniqueCampaignAnalysisRows([...state.campaign_analysis, ...rows])
      : rows,
    loading: false,
    last_fetched_at: new Date(),
    last_page_fetched: safePage,
    last_start_date: additional.start_date,
    last_end_date: additional.end_date,
    total_number_of_pages: safeTotal,
    has_next_page: hasNextPage,
    has_lookahead_pages: hasLookAheadPages,
    page_cache: useCache ? {
      ...state.page_cache,
      [cacheKey]: {
        ...(state.page_cache?.[cacheKey] || {}),
        [safePage]: pageSnapshot,
      },
    } : state.page_cache,
  }
}

export const handleGetCampaignAnalysisError = (state, action) => ({
  ...state,
  error: action.payload,
  loading: false,
})

export const handleGetPingDetails = (state) => ({
  ...state,
  ping_details_loading: true,
  ping_details_error: null,
})

export const handleGetPingDetailsSuccess = (state, action) => ({
  ...state,
  ping_details_loading: false,
  ping_details: action.payload,
})

export const handleGetPingDetailsError = (state, action) => ({
  ...state,
  ping_details_loading: false,
  ping_details_error: action.payload,
})
